import { css } from '@emotion/css';

export const listStyles = css`
  :last-child {
    border: none;
  }
`;
